//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        label: String,
        icon: String,
        disable: Boolean,
        primary: Boolean,
        wide: Boolean,
        large: Boolean,
        narrow: Boolean,
        noCaps: Boolean,
    },
};
